import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Route, Router, RouterStateSnapshot, UrlSegment,} from '@angular/router';
import {AuthService} from '@auth0/auth0-angular';
import {filter, map, mergeMap, tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {MonoTypeOperatorFunction, Observable, of} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class CustomAuthGuard implements CanActivate {
  constructor(protected router: Router, private authService: AuthService) {
  }

  private redirectIfUnauthenticated(state: RouterStateSnapshot) {
    return this.authService.isAuthenticated$.pipe(tap((logged) => {
      if (!logged) {
        this.authService.loginWithRedirect({appState: {target: state.url}});
      }
    }));
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.redirectIfUnauthenticated(state).pipe(filter(value => value), this.checkIfGroupIsPermitted(next), this.redirectToForbiddenWhenNotAllowed());
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.redirectIfUnauthenticated(state).pipe(filter(value => value), this.checkIfGroupIsPermitted(childRoute), this.redirectToForbiddenWhenNotAllowed());
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    return this.authService.isAuthenticated$.pipe(filter(value => value), this.checkIfGroupIsPermitted(route), this.redirectToForbiddenWhenNotAllowed());
  }

  checkIfGroupIsPermitted(route: ActivatedRouteSnapshot | Route): MonoTypeOperatorFunction<any> {
    if (!route?.data?.groups || route?.data?.groups.length === 0) {
      return tap();
    }

    // @ts-ignore
    return mergeMap(() => {
      const accessToken: Observable<any> = this.authService.getAccessTokenSilently();
      console.log("AccesToken" + accessToken);
      if (!accessToken) {
        window.location.href = environment.forbiddenErrorUrl
        return null;
      }
      return accessToken.pipe(map(token => atob(token.split('.')[1])), map(userString => {
        const user = JSON.parse(userString);
        console.log("user" + user);
        const userGroups: string[] = user[environment.groupsClaimName];
        console.log("userGroup" + userGroups);
        const requiredGroup: string[] = route?.data?.groups;
        console.log("RequiredGroup" + requiredGroup);
        return requiredGroup.some(group => userGroups.includes(group));
      }))
    })
  }

  redirectToForbiddenWhenNotAllowed() {
    return tap((value: boolean) => {
      if (value === false) window.location.href = environment.forbiddenErrorUrl
    })
  }
}

